/**
 * Group historic inbox threads by workspace for the agent profile right rail.
 * @param {Array<{ workspaceId?: string | null, workspaceName?: string | null, [key: string]: unknown }>} threads
 * @returns {Array<{ workspaceId: string | null, workspaceName: string, threads: typeof threads }>}
 */
export function groupHistoricThreadsByWorkspace(threads) {
  if (!Array.isArray(threads) || threads.length === 0) {
    return [];
  }

  /** @type {Map<string, { workspaceId: string | null, workspaceName: string, threads: typeof threads }>} */
  const byKey = new Map();

  for (const thread of threads) {
    const wsId = thread.workspaceId != null && String(thread.workspaceId).trim()
      ? String(thread.workspaceId).trim()
      : null;
    const wsName = thread.workspaceName != null && String(thread.workspaceName).trim()
      ? String(thread.workspaceName).trim()
      : "";
    const key = wsId || wsName || "__unknown__";
    const label = wsName || (wsId ? "Workspace" : "Unknown workspace");

    if (!byKey.has(key)) {
      byKey.set(key, { workspaceId: wsId, workspaceName: label, threads: [] });
    }
    byKey.get(key).threads.push(thread);
  }

  return Array.from(byKey.values()).sort((a, b) =>
    a.workspaceName.localeCompare(b.workspaceName, undefined, { sensitivity: "base" }),
  );
}
